import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../utils/apiConfig';
export default function OnlineOrderFulfillment({ order, token, onChanged }) {
  const [sources, setSources] = useState([]);
  const [search, setSearch] = useState(order.fulfillment?.source?.label || '');
  const [selected, setSelected] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    fetch(`${API_BASE_URL}/orders/online/delivery-sources`, { headers: { Authorization: `Bearer ${token}` }, signal: controller.signal })
      .then(async response => { const data = await response.json(); if (!response.ok) throw Error(data.message || 'Unable to load sources'); return data; })
      .then(setSources).catch(e => { if (!controller.signal.aborted) setError(e.message); });
    return () => controller.abort();
  }, [token]);
  const state = order.fulfillment?.state;
  const reserved = ['confirmed','confirming'].includes(state);
  const action = async verb => {
    setBusy(true); setError('');
    try {
      const response = await fetch(`${API_BASE_URL}/orders/online/${order._id}/${verb}`, {
        method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ source: selected || order.fulfillment?.source }),
      });
      const data = await response.json();
      if (!response.ok) throw Error(data.message || 'Fulfillment update failed');
      await onChanged();
    } catch(e) { setError(e.message); } finally { setBusy(false); }
  };
  return <section className="rounded-lg border bg-blue-50 p-4">
    <h3 className="font-semibold">Delivery from</h3>
    {state === 'delivered' ? <p>Delivered from {order.fulfillment.source.label}. Stock deducted and finance assigned.</p> : reserved ? <>
      <p>Reserved at {order.fulfillment.source.label}. Stock is deducted when delivered.</p>
      <div className="mt-3 flex gap-2">
        <button disabled={busy || state !== 'confirmed'} onClick={() => action('deliver')} className="rounded bg-green-700 px-3 py-2 text-white">Mark delivered</button>
        <button disabled={busy || state !== 'confirmed'} onClick={() => action('release')} className="rounded border px-3 py-2">Release reservation</button>
        {state === 'confirming' && <button disabled={busy} onClick={() => action('confirm')}>Retry confirmation</button>}
      </div>
    </> : <>
      <input aria-label="Search delivery outlets or inventory" value={search} disabled={busy}
        onChange={e => { setSearch(e.target.value); setSelected(null); }} placeholder="Search outlets or inventory" className="mt-2 w-full rounded border p-2" />
      {!selected && <ul className="mt-2 max-h-44 overflow-auto">{sources.filter(s => s.label.toLowerCase().includes(search.toLowerCase())).map(s =>
        <li key={`${s.type}:${s.id}`}><button disabled={busy} onClick={() => { setSelected(s); setSearch(s.label); }} className="w-full p-2 text-left hover:bg-blue-100">
          {s.label} · {s.type === 'outlet'?'Outlet':'Inventory'}</button></li>)}</ul>}
      <button disabled={busy || !selected} onClick={() => action('confirm')} className="mt-3 rounded bg-blue-700 px-3 py-2 text-white disabled:opacity-50">Confirm & reserve stock</button>
    </>}
    {busy && <p role="status">Updating…</p>}
    {error && <p role="alert" className="mt-2 text-red-700">{error}</p>}
  </section>;
}
